export default "__VITE_ASSET__6085cfb2__"